import { render, staticRenderFns } from "./evaluationStatistics.vue?vue&type=template&id=0adcd798&scoped=true&"
import script from "./evaluationStatistics.vue?vue&type=script&lang=js&"
export * from "./evaluationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./evaluationStatistics.vue?vue&type=style&index=0&id=0adcd798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adcd798",
  null
  
)

export default component.exports